// extracted by mini-css-extract-plugin
export default {"screensaver":"ScreensaverContainer_screensaver__vM-5p","cover":"ScreensaverContainer_cover__AW+Gp"};